import type { SyntheticEvent } from 'react';
import { Button } from '@simplywallst/ui-core';
import CheckSolid from '@simplywallst/ui-core/icons/CheckSolid';

import { useNarrativeSelectValuationOption } from '@/components/NarrativeFairValue/components/NarrativeFairValueModal/hooks/useNarrativeSelectValuationOption';
import { Narrative } from '@/pages/Narrative/hooks/useNarrativeById';

type Props = {
  narrative: Narrative;
};

export const NarrativeSetFairValue = ({ narrative }: Props) => {
  const { companyId, id, isPrimary } = narrative;
  const { mutate, status } = useNarrativeSelectValuationOption();

  const handleOnClick = () => {
    return (event: SyntheticEvent) => {
      event.preventDefault();
      event.stopPropagation();
      if (!isPrimary) {
        mutate({
          input: {
            companyId: companyId,
            narrativeId: id,
            type: 'USER_DEFINED',
          },
        });
      }
    };
  };

  return (
    <Button
      isLoading={status === 'pending'}
      disabled={status === 'pending'}
      styleType={isPrimary ? 'loudLarge' : 'gentleLarge'}
      onClick={handleOnClick}
    >
      {isPrimary ? (
        <>
          <CheckSolid />
          &nbsp;Fair Value
        </>
      ) : (
        'Set as Fair Value'
      )}
    </Button>
  );
};
